import React from 'react';
import { ChakraProvider, Box, Center, Spinner, extendTheme } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { LanguageProvider } from './hooks/useLanguage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import RiskRegisterPage from './pages/RiskRegisterPage';
import RiskForm from './pages/RiskForm';
import DepartmentManagement from './pages/DepartmentManagement';
import UserManagement from './pages/UserManagement';
import RoleManagement from './pages/RoleManagement';
import Layout from './components/Layout';

const theme = extendTheme({
  fonts: {
    heading: `'Sarabun', sans-serif`,
    body: `'Sarabun', sans-serif`,
  },
});

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const App: React.FC = () => {
  return (
    <ChakraProvider theme={theme}>
      <LanguageProvider>
        <AuthProvider>
          <Router basename="/RiskRegister">
            <Box minH="100vh" bg="gray.50">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/*"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <Routes>
                          <Route path="/" element={<Dashboard />} />
                          <Route path="/dashboard" element={<Dashboard />} />
                          <Route path="/risk-register" element={<RiskRegisterPage />} />
                           <Route path="/risk-register/new" element={<RiskForm />} />
                          <Route path="/departments" element={<DepartmentManagement />} />
                          <Route path="/users" element={<UserManagement />} />
                          <Route path="/roles" element={<RoleManagement />} />
                        </Routes>
                      </Layout>
                    </PrivateRoute>
                  }
                />
              </Routes>
            </Box>
          </Router>
        </AuthProvider>
      </LanguageProvider>
    </ChakraProvider>
  );
};

export default App;
